import { fetchAll, updateDocById, deleteDocById } from "./firestoreHelpers";
import { savePersona, claveDedup } from "./dedupPersona";
import { renameLocatarioOnContratos } from "./contratos";
import { nombreCompleto } from "../utils/nombre";

const COLL = "alquileres_locatarios";

// Dedup/search key is the full "Apellido Nombre" (falls back to nombre).
const normalizeName = claveDedup;

export const getLocatarios = async () => fetchAll(COLL);

export const saveLocatario = async (data) => savePersona(COLL, data);

export const updateLocatario = async (id, data) => {
  const renamed = data.nombre !== undefined || data.apellido !== undefined;
  const patch = renamed
    ? { ...data, nombreNormalizado: normalizeName(data) }
    : data;
  await updateDocById(COLL, id, patch);
  // Keep the denormalized locatarioNombre on every contrato in sync with the rename.
  if (renamed) {
    await renameLocatarioOnContratos(id, nombreCompleto(data));
  }
  return id;
};

export const deleteLocatario = async (id) => deleteDocById(COLL, id);
